import { Helmet } from 'react-helmet-async';
import { useLocation } from 'wouter';
import { SITE_URL, SOCIAL_IMAGE_URL } from '@/lib/brand';
import { BRAND_NAME } from '@/config/brand';

// Baseline for routes without their own SEO. Nested Helmet tags override these
// without leaving the crawler HTML's old values duplicated in the browser head.
export function DefaultSEO() {
  const [path] = useLocation();
  const url = `${SITE_URL}${path}`;
  const title = `${BRAND_NAME} - Quotes, scheduling and invoices for service businesses`;
  const description = 'Send professional quotes, schedule the crew and get invoices paid online. Software for service businesses.';
  return <Helmet>
    <title>{title}</title>
    <link rel="canonical" href={url} />
    <meta property="og:type" content="website" />
    <meta property="og:url" content={url} />
    <meta property="og:site_name" content={BRAND_NAME} />
    <meta property="og:title" content={title} />
    <meta property="og:description" content={description} />
    <meta property="og:image" content={SOCIAL_IMAGE_URL} />
    <meta property="og:image:width" content="1200" />
    <meta property="og:image:height" content="630" />
    <meta property="og:locale" content="en_US" />
    <meta name="twitter:card" content="summary_large_image" />
    <meta name="twitter:url" content={url} />
    <meta name="twitter:title" content={title} />
    <meta name="twitter:description" content={description} />
    <meta name="twitter:image" content={SOCIAL_IMAGE_URL} />
  </Helmet>;
}
